/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__edit__additional_data_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Weitere nützliche Informationen.`
};

const en_route_details__expense_note_section__edit__additional_data_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Any other useful information.`
};

const es_route_details__expense_note_section__edit__additional_data_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Cualquier otra información útil.`
};

const fr_route_details__expense_note_section__edit__additional_data_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Toutes autres informations utiles.`
};

const it_route_details__expense_note_section__edit__additional_data_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Tutte le altre informazioni utili.`
};

const nl_route_details__expense_note_section__edit__additional_data_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Alle andere nuttige informatie.`
};

const pt_route_details__expense_note_section__edit__additional_data_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Qualquer outra informação útil.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__edit__additional_data_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__edit__additional_data_placeholder", locale)
	if (locale === "de") return de_route_details__expense_note_section__edit__additional_data_placeholder(inputs)
	if (locale === "en") return en_route_details__expense_note_section__edit__additional_data_placeholder(inputs)
	if (locale === "es") return es_route_details__expense_note_section__edit__additional_data_placeholder(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__edit__additional_data_placeholder(inputs)
	if (locale === "it") return it_route_details__expense_note_section__edit__additional_data_placeholder(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__edit__additional_data_placeholder(inputs)
	return pt_route_details__expense_note_section__edit__additional_data_placeholder(inputs)
};